<div class="topHead">
    <a href="javascript:void(0);" class="adminBack" [routerLink]="['/authoring_list']"><img src="assets/images/admin/backarrow.png" />Back to Content Authoring</a>
    <!-- <div class="logout">
        <b>Pratibha Sharma</b>
        <a href="javascript:void(0);"><img src="assets/images/admin/power.png"/> </a>
    </div> -->
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>
<div class="centerWrap mt-4 pt-2">
    <div class="adminInnerHead">
        <div class="row">
            <div class="col-12 col-md-4">
                <div class="userDetail">
                    <h2>{{contentDetailsData?.capsule_name}}<small>Created on
                        {{contentDetailsData?.created_dttm}}</small></h2>
                        <ul class="modifyIcons mb-0">
                            <li
                                *ngIf="contentDetailsData?.assessment_id && contentDetailsData.assessment_id!=null && contentDetailsData.assessment_id!=''">
                                <a href="javascript:void(0);"><img src="assets/images/icons/frame.svg"></a>
                            </li>
                            <li
                                *ngIf="(contentDetailsData?.contentCapsuleMedia) && (getMediaType(contentDetailsData.contentCapsuleMedia,'1')==true)">
                                <a href="javascript:void(0);"><img src="assets/images/icons/text.svg"></a>
                            </li>
                            <li
                                *ngIf="(contentDetailsData?.contentCapsuleMedia) && (getMediaType(contentDetailsData.contentCapsuleMedia,'2')==true)">
                                <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg"></a>
                            </li>
                            <li
                                *ngIf="(contentDetailsData?.contentCapsuleMedia) && (getMediaType(contentDetailsData.contentCapsuleMedia,'3')==true)">
                                <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg"></a>
                            </li>
                        </ul>
                     
                </div>
            </div>
            <div class="col-12 col-md-8">
                <ul class="customTab">
                    <li><a href="javascript:void(0);" [routerLink]="['/authoring_avtivated']" [queryParams]="{id:capsuleId}" >ACTIVE COURSES<br/>
                        (ASSIGNED TO)</a> </li>
                    <li><a href="javascript:void(0);" [routerLink]="['/authoring_deavtivated']" [queryParams]="{id:capsuleId}" class="active">DEACTIVATED COURSES<br/>
                        (ASSIGNED TO)</a> </li>
                    <li><a href="javascript:void(0);" [routerLink]="['/authoring_viewContent']" [queryParams]="{id:capsuleId}">VIEW</a> </li>
                    <li><a href="javascript:void(0);" (click)="open(duplicate,capsuleId)">Duplicate</a>
                    </li>
                    <li class="deactiveTab" *ngIf="contentDetailsData?.is_active == 1"><a href="javascript:void(0);"
                            (click)="open(deactivate,capsuleId)">DEACTIVATE</a> </li>
                    <li class="deactiveTab" *ngIf="contentDetailsData?.is_active == 0"><a href="javascript:void(0);"
                            (click)="open(activate,capsuleId)">ACTIVATE</a> </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="formHeading">
        <div class="row m-0">
            <div class="col-12 col-md-6">
        <h2>Deactivated Courses (Assigned to)</h2>
        <p>Complete list of courses this content capsule is assigned to.</p>
    </div>
    <div class="col-12 col-md-6">
        <div class="filterWrap"  style="margin-top: 0px;">
            <div class="searchWrap">
                <input type="text" placeholder="Search Courses" (keyup)="search($event)" />
            </div>
        </div>
        </div>
    </div>
    </div>


    <div class="tableWrap">
        <div class="tableWrap">
            <table matSort (matSortChange)="sortData($event)">
                <thead>
                    <tr>
                        <th><div mat-sort-header="course_name"><b></b> Course Name</div></th>
                        <th>Description</th>
                        <th>Modules</th>
                        <th>Sub Modules</th>
                        <th>Assessments</th>
                        
                    </tr>
                </thead>
                <tbody>
                    <tr class="selectTrCourse" *ngFor="let values of userCourseList; let i = index">
                        <!-- <td>
                            <div class="courseTdWrap">
                                <a href="javascript:void(0);">Beginners Course - Motor Engine </a>
                                <b>Assigned on 3 Feb, 2021</b>
                            </div>
                        </td> -->
                        <td>
                            <div class="courseTdWrap">
                                <a href="javascript:void(0);">{{values.course_name}} </a><br>
                                <b>Assigned on {{values.created_dttm | date:'d MMM, y'}}</b>
                            </div>
                        </td>
                        <td><p class="discription">{{values.course_desc}}</p></td>
                        <td>{{values.total_module}}</td>
                        <td>{{values.total_sub_module}}</td>
                        <td>{{values.total_assessement}}</td>
                        <!-- <td>{{values.no_of_modules_completed == null ? '0': values.no_of_modules_completed}}/{{values.total_module}}</td>
                        <td>{{values.no_of_assessments_passed == null ? '0': values.no_of_assessments_passed}}/{{values.total_assessement}}</td> -->
                    </tr>
               </tbody>
            </table>
        </div>
    </div>
</div>
<ng-template #duplicate let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Duplicate content capsule</h6>
                <p class="size18">Are you sure you want to Duplicate this content capsule?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="duplicateCapsule(content_capsule_ids)">Yes, Duplicate</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #deactivate let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>DeActivate content capsule</h6>
                <p class="size18">Are you sure you want to deactivate this content capsule?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="changeIsDeActiveVal(content_capsule_ids,0)">Yes, DeActivate</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #activate let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Activate content capsule</h6>
                <p class="size18">Are you sure you want to activate this content capsule?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="changeIsDeActiveVal(content_capsule_ids,1)">Yes, Activate</a>
            </div>
        </div>
    </div>
</ng-template>
